import { Config } from "./parts/vars/types";

export const config: Config = {
  triggerPos: {
    pc: "80%",
    sp: "90%",
  },
  breakPoint: 768,
  headerHidingPoint: 100,
  newsUrl: "https://note.com/hiroshima_sb/m/m5b0f5cc2b371/rss",
  // MicroCMS: 管理画面の「API設定」から GET用 APIキー を設定
  // ※ブラウザキーをフロントに出す場合は、Referer制限を必ず設定すること
  microcms: {
    serviceDomain: "YOUR_SERVICE_DOMAIN",
    apiKey: "YOUR_API_KEY",
    endpoint: "columns",
    limit: 3,
    listPath: "/column/",
    detailBasePath: "/column/",
  },
};
